// Search types
const SEARCH_TYPES = {
  news: 'News',
  resources: 'Resources',
  faq: 'FAQ',
  contacts: 'Contacts',
  'office-locations': 'Office Locations'
}

// Search topic types
const SEARCH_TOPIC_TYPES = [
  { id: '', name: 'All search results' },
  { id: 'news', name: 'News' },
  { id: 'resources', name: 'Resources' },
  { id: 'faq', name: 'FAQ' },
  { id: 'contacts', name: 'Contacts' },
  { id: 'office-locations', name: 'Office Locations' }
]

export {
  SEARCH_TYPES,
  SEARCH_TOPIC_TYPES
}
